import React from 'react';
import { getTextColorByBG } from '../../../utils/utils';

function SmallCampaignTiles(props) {
    return (
        <div
            style={{
                // backgroundColor: 
                // props?.completedCampaigns ? 'unset' :
                // (props?.pageSettings?.secondary_color ? props?.pageSettings?.secondary_color : '#daeffffa')
            }}
            className={` d-sm-block d-block d-md-none campaign-main-section  pb-3 pt-2 ${props?.featuredItems?.length > 0 ? 'pt-3' : ''}`}>
            <div className='container '>
                <div className={`row  g-2 ${(props?.featuredItems?.length > 0 && !props?.completedCampaigns) ? ' mt-4' : ''}`}>
                    {
                        props?.storeItems?.map((item, index) => {
                            return <div

                                key={`icon-tiles` + index} className={` col-12 col-sm-6 text-center`}>
                                <a href={
                                    !props?.completedCampaigns ? 
                                    (item?.type === 'product' ?
                                        `
                                                        ${props?.organizationInfo?.organization_short_name ?
                                            props?.organizationInfo?.organization_short_name : 'masjid'
                                        }/product/${item.donation_page_link}` : `${props?.organizationInfo?.organization_short_name ?
                                            props?.organizationInfo?.organization_short_name : 'masjid'
                                        }/campaign/${item.donation_page_link}`) : null
                                }>
                                   <div className='product' style={{
                             '--primary-color': props?.pageSettings?.button_color ? props?.pageSettings?.button_color : '#004475'
}}>
    <div>
        <div className='d-flex justify-content-between align-items-center' style={{minHeight:'28px'}}>
            <div></div>
            <div>
                {
                    item?.type === 'product' ? (
                        (item?.reset_count?.toLowerCase() !== 'yearly' && item?.reset_count?.toLowerCase() !== 'monthly' && (item?.remainingQuantity || item?.quantity || item?.remaining_quantity)) ? (
                            <span style={{
                                color: props?.pageSettings?.secondary_color ? getTextColorByBG(props?.pageSettings?.secondary_color) : '#004475',
                                backgroundColor: props?.pageSettings?.secondary_color ? props?.pageSettings?.secondary_color : '#DAEFFF'
                            }} className='remaining-quantity'>
                                {item?.remainingQuantity ?? item?.quantity ?? item?.remaining_quantity} left
                            </span>
                        ) : ''
                    ) : (
                        Number(item?.goal_amount) > 0 ? (
                            <span style={{
                                color: props?.pageSettings?.secondary_color ? getTextColorByBG(props?.pageSettings?.secondary_color) : '#004475',
                                backgroundColor: props?.pageSettings?.secondary_color ? props?.pageSettings?.secondary_color : '#DAEFFF'
                            }} className='remaining-quantity'>
                                Goal: ${Number(item?.goal_amount || 0).toLocaleString()}
                            </span>
                        ) : ''
                    )
                }
            </div>
        </div>
        <h6 style={{
            minHeight: '50px', maxHeight: '50px', overflow: 'hidden'
        }}
            className='mt-2 text-black'>{item?.campaign_title}
        </h6>
        <p style={{
            minHeight: '40px', maxHeight: '40px', overflow: 'hidden'
        }}
            className='mb-0 mt-1 f-12-small'>{item?.subtitle}
        </p>
        {
            !props?.completedCampaigns ?
                item?.type === 'product' ?
                    <div className='card-price mt-2 mb-0'>
                        <span className='card-price-val'>${item?.price_per_unit / 100}</span>
                        {item?.unit_label && (
                            <span className='card-price-unit product-small-tile-unit'>
                                {item.unit_label.toLowerCase().startsWith('per') ? item.unit_label.toLowerCase() : `per ${item.unit_label.toLowerCase()}`}
                            </span>
                        )}
                    </div> : ''
                : <div className='f-18 mt-3 completed-campaign text-center pt-2 mb-0'>
                    Completed
                </div>
        }
    </div>
    {
        !props?.completedCampaigns ?
            <div className='donate'>
                <a href={
                    item?.type === 'product' ?
                        `${props?.organizationInfo?.organization_short_name ? props?.organizationInfo?.organization_short_name : 'masjid'}/product/${item.donation_page_link}` :
                        `${props?.organizationInfo?.organization_short_name ? props?.organizationInfo?.organization_short_name : 'masjid'}/campaign/${item.donation_page_link}`
                } style={{
                    backgroundColor: props?.pageSettings?.button_color ? props?.pageSettings?.button_color : '#004475',
                    color: getTextColorByBG(props?.pageSettings?.button_color ? props?.pageSettings?.button_color : '#004475')
                }} target='_blank' className='btn w-100 m-0 donate-now'>
                    {item?.change_label_to_pay ? 'Pay' : 'Donate'}
                </a>
            </div> : ''
    }
</div>
                                </a>

                            </div>
                        })
                    }

                </div>
            </div>

            {
                props?.completedItems?.length === 0 && props?.storeItems?.length > 0 ?
                    props?.footer() : ''
            }
        </div>
    );
}

export default SmallCampaignTiles;